/**
 * 横向填满布局
 */
BI.HorizontalFillLayout = function () {
};
BI.shortcut("bi.horizontal_fill", BI.HorizontalFillLayout);
